
/**
 * Defines the point thresholds for each karma level
 */
export const levelThresholds = [0, 100, 250, 500, 1000, 2000];

/**
 * Calculates the current level based on karma points
 */
export const getCurrentLevel = (points: number): number => {
  let level = 0;
  for (let i = 0; i < levelThresholds.length; i++) {
    if (points >= levelThresholds[i]) {
      level = i;
    } else {
      break;
    }
  }
  return level;
};

/**
 * Calculates the progress percentage to the next level
 */
export const getProgressToNextLevel = (points: number): number => {
  const currentLevel = getCurrentLevel(points);
  if (currentLevel >= levelThresholds.length - 1) {
    return 100; // Max level reached
  }
  
  const currentThreshold = levelThresholds[currentLevel];
  const nextThreshold = levelThresholds[currentLevel + 1];
  const pointsInCurrentLevel = points - currentThreshold;
  const pointsNeededForNextLevel = nextThreshold - currentThreshold;
  
  return Math.round((pointsInCurrentLevel / pointsNeededForNextLevel) * 100);
};
